import { render, staticRenderFns } from "./ClaimsSubmittedByOrganizationBarChart.vue?vue&type=template&id=a4455c12"
import script from "./ClaimsSubmittedByOrganizationBarChart.vue?vue&type=script&lang=js"
export * from "./ClaimsSubmittedByOrganizationBarChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports